import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { ScrollReveal } from '../components/ui/ScrollReveal';
import { Button } from '../components/ui/Button';
import { LicensedExperiences } from '../components/LicensedExperiences';
export function ResortsPage() {
  return <div className="w-full pt-24" data-id="element-985">
      <section className="py-24 md:py-32 bg-brand-green-deep text-brand-cream-light relative overflow-hidden" data-id="element-986">
        <div className="absolute inset-0 bg-concept-resort opacity-30 mix-blend-overlay" data-id="element-987" />
        <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-988">
          <SectionHeading eyebrow="Resorts & Hospitality" title="Guest-facing golf experiences that drive engagement." subtitle="Turn unused space into a social, shareable amenity that keeps guests on property longer." light data-id="element-989" />
        </div>
      </section>

      <section className="py-24 bg-brand-cream-light" data-id="element-990">
        <div className="max-w-7xl mx-auto px-6" data-id="element-991">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-992">
            <ScrollReveal delay={0.1} data-id="element-993">
              <h3 className="text-2xl font-heading text-brand-green-deep mb-4" data-id="element-994">
                Family & Social Play
              </h3>
              <p className="text-brand-stone font-body" data-id="element-995">
                An accessible, high-end activity that appeals to golfers and
                non-golfers alike, perfect for afternoon downtime or
                after-dinner drinks.
              </p>
            </ScrollReveal>
            <ScrollReveal delay={0.2} data-id="element-996">
              <h3 className="text-2xl font-heading text-brand-green-deep mb-4" data-id="element-997">
                Wedding & Event Feature
              </h3>
              <p className="text-brand-stone font-body" data-id="element-998">
                A unique activation for wedding weekends, corporate retreats,
                and private events that photographs beautifully.
              </p>
            </ScrollReveal>
            <ScrollReveal delay={0.3} data-id="element-999">
              <h3 className="text-2xl font-heading text-brand-green-deep mb-4" data-id="element-1000">
                Content Engine
              </h3>
              <p className="text-brand-stone font-body" data-id="element-1001">
                Designed to be highly visual and shareable, generating organic
                social media content from your guests.
              </p>
            </ScrollReveal>
          </div>
        </div>
      </section>

      <LicensedExperiences data-id="element-1002" />

      <section className="py-24 bg-brand-charcoal text-brand-cream-light" data-id="element-1003">
        <div className="max-w-7xl mx-auto px-6 text-center" data-id="element-1004">
          <ScrollReveal data-id="element-1005">
            <h2 className="text-4xl font-heading mb-6" data-id="element-1006">
              Powered by PuttLab Play
            </h2>
            <p className="text-xl font-body text-brand-cream/80 max-w-2xl mx-auto mb-12" data-id="element-1007">
              Add our QR-enabled digital layer to allow guests to keep score,
              compete on resort-wide leaderboards, and share branded winner
              cards.
            </p>
            <Button variant="primary" href="/play" data-id="element-1008">
              Learn about PuttLab Play
            </Button>
          </ScrollReveal>
        </div>
      </section>
    </div>;
}